import React, { useEffect } from 'react';
import { Form, Select, Input, DatePicker, Alert } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';
import { NIVEAUX_JURIDICTION } from '../variables/constants';
import CBModal from './CBModal';

const { TextArea } = Input;
const RED = '#b42318';
const RED_LINE = '#f04438';
const RED_SOFT = '#fff5f5';

/**
 * Passage d'un dossier en CONTENTIEUX (procédure judiciaire).
 * Capture niveau de juridiction et prochaine audience pour alimenter les alertes Délais.
 */
export default function ContentieuxModal({ open, onClose, onConfirm, sinistre, loading }) {
  const { t } = useTranslation('commun');
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) form.resetFields();
  }, [open, form]);

  const handleOk = async () => {
    try {
      const v = await form.validateFields();
      onConfirm({
        niveauJuridiction:     v.niveauJuridiction,
        dateProchaineAudience: v.dateProchaineAudience?.format('YYYY-MM-DD') || null,
        observations:          v.observations?.trim() || null,
      });
    } catch { /* validation inline */ }
  };

  return (
    <CBModal
      title={<span><ExclamationCircleOutlined style={{ color: RED, marginRight: 8 }} />{t('contentieuxModal.titre')}</span>}
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText={t('contentieuxModal.titre')}
      cancelText={t('contentieuxModal.annuler')}
      width={560}
      confirmLoading={loading}
      okButtonProps={{ danger: true }}
      styles={{
        content: {
          border: `2px solid ${RED_LINE}`,
          boxShadow: '0 18px 45px rgba(180, 35, 24, 0.22)',
          overflow: 'hidden',
        },
        header: {
          background: RED_SOFT,
          borderBottom: '1px solid #ffd5d2',
          paddingBottom: 12,
        },
        body: {
          background: '#fffafa',
          paddingTop: 18,
        },
        footer: {
          background: '#fffafa',
          borderTop: '1px solid #ffe4e1',
          paddingTop: 12,
        },
      }}
      destroyOnClose
    >
      <Alert
        type="warning"
        showIcon
        style={{
          marginBottom: 16,
          borderColor: '#fecaca',
          background: RED_SOFT,
        }}
        message={t('contentieuxModal.alerteTitre')}
        description={
          <Trans
            t={t}
            i18nKey="contentieuxModal.alerteTexte"
            values={{ numero: sinistre?.numeroSinistreLocal || '' }}
            components={{ 1: <strong /> }}
          />
        }
      />

      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          name="niveauJuridiction"
          label={t('contentieuxModal.niveauJuridiction')}
          rules={[{ required: true, message: t('contentieuxModal.selectionnezNiveau') }]}
        >
          <Select
            placeholder={t('contentieuxModal.selectionner')}
            options={NIVEAUX_JURIDICTION.map(n => ({ value: n.value, label: n.label }))}
          />
        </Form.Item>

        <Form.Item
          name="dateProchaineAudience"
          label={t('contentieuxModal.dateProchaineAudience')}
          tooltip={t('contentieuxModal.alerteDelais')}
        >
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder={t('contentieuxModal.formatDate')} />
        </Form.Item>

        <Form.Item name="observations" label={t('contentieuxModal.observations')}>
          <TextArea
            rows={3}
            placeholder={t('contentieuxModal.observationsExemple')}
            maxLength={1000}
            showCount
          />
        </Form.Item>
      </Form>
    </CBModal>
  );
}
